var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL---Landing-Page",
    transform: "translate(-1591, -7396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(-0, 7227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(1592, 170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    stroke: "#C6A566",
    strokeWidth: 2,
    fill: "#1A1A1A",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(12, 15)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66237778,4.14493419 C9.31848889,3.95038778 8.89598889,3.95178478 8.55341111,4.1485972 C8.21084444,4.34540962 8,4.70788239 8,5.10000023 L8,13.900019 C8,14.2921699 8.21084444,14.6546206 8.55341111,14.851411 C8.89598889,15.0482015 9.31848889,15.0496315 9.66237778,14.8550411 L17.4401111,10.4550317 C17.7863333,10.2592312 18,9.89480047 18,9.5 C18,9.10521878 17.7863333,8.740788 17.4401111,8.54498759 L9.66237778,4.14493419 Z M14.6493333,9.50000963 L10.2222222,12.004495 L10.2222222,6.99550228 L14.6493333,9.50000963 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.5 C0,5.54195167 0,3.56292222 1.03449125,2.17557389 C1.36858583,1.72752222 1.77298333,1.33349389 2.23282583,1.00796056 C3.65668333,0 5.6877925,0 9.75,0 L16.25,0 C20.312175,0 22.3433167,0 23.7671417,1.00796056 C24.2270167,1.33349389 24.631425,1.72752222 24.965525,2.17557389 C26,3.56292222 26,5.54195167 26,9.5 C26,13.4580167 26,15.4370778 24.965525,16.8243944 C24.631425,17.2724778 24.2270167,17.6665167 23.7671417,17.99205 C22.3433167,19 20.312175,19 16.25,19 L9.75,19 C5.6877925,19 3.65668333,19 2.23282583,17.99205 C1.77298333,17.6665167 1.36858583,17.2724778 1.03449125,16.8243944 C0,15.4370778 0,13.4580167 0,9.5 Z M9.75,2.11111111 L16.25,2.11111111 C18.32935,2.11111111 19.714825,2.11401389 20.764575,2.22482611 C21.7738083,2.33136333 22.2126667,2.51695111 22.4936833,2.71589167 C22.7695,2.91121167 23.0121667,3.14762444 23.2126917,3.41645333 C23.4167917,3.690275 23.6072417,4.11785944 23.7166583,5.10117278 C23.8304083,6.123985 23.8333333,7.47396667 23.8333333,9.5 C23.8333333,11.5260333 23.8304083,12.8759833 23.7166583,13.8988167 C23.6072417,14.8821722 23.4167917,15.3097778 23.2126917,15.5835889 C23.0121667,15.8523333 22.7695,16.0887778 22.4936833,16.2841611 C22.2126667,16.4830278 21.7738083,16.6685944 20.764575,16.7752056 C19.714825,16.8860389 18.32935,16.8888889 16.25,16.8888889 L9.75,16.8888889 C7.67062833,16.8888889 6.2851425,16.8860389 5.23541417,16.7752056 C4.22622417,16.6685944 3.7873875,16.4830278 3.50636,16.2841611 C3.23045667,16.0887778 2.9878225,15.8523333 2.7873625,15.5835889 C2.58318667,15.3097778 2.392715,14.8821722 2.28337417,13.8988167 C2.16964583,12.8759833 2.16666667,11.5260333 2.16666667,9.5 C2.16666667,7.47396667 2.16964583,6.123985 2.28337417,5.10117278 C2.392715,4.11785944 2.58318667,3.690275 2.7873625,3.41645333 C2.9878225,3.14762444 3.23045667,2.91121167 3.50636,2.71589167 C3.7873875,2.51695111 4.22622417,2.33136333 5.23541417,2.22482611 C6.2851425,2.11401389 7.67062833,2.11111111 9.75,2.11111111 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.78a93b35c94a96116e07845d8ddaa32f.svg";
export { ForwardRef as ReactComponent };